<template>
  <div id="addon-vessel-report-view">
    <vs-alert
      color="danger"
      title="レポートが見つかりませんでした"
      :active.sync="notFound"
    >
      <span>
        <router-link
          :to="{ name: 'addon-vessel-report-list' }"
          class="text-inherit underline"
          >レポート一覧へ戻る</router-link
        >
      </span>
    </vs-alert>

    <div v-if="!notFound">
      <div class="flex flex-wrap items-center justify-between">
        <div class="flex items-center"></div>
        <div class="flex items-center">
          <vs-button
            class="mb-base mr-3"
            icon-pack="feather"
            icon="icon-printer"
            @click="printReport"
            >プリント</vs-button
          >
        </div>
      </div>

      <vs-row vs-w="12">
        <vs-col class="lg:pr-8 pr-0" vs-sm="12" vs-lg="8" vs-justify="flex-start" vs-align="flex-start">
          <vessel-report :reportId="reportId" />
        </vs-col>
        <vs-col class="lg:mt-0 mt-8" vs-sm="12" vs-lg="4" vs-justify="flex-start" vs-align="flex-start">
          <report-confirmor-list confirmor="confirmor" />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
import VesselReport from "./components/VesselReport";
import ReportConfirmorList from "./components/ReportConfirmorList";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("vesselReportView");

export default {
  components: {
    VesselReport,
    ReportConfirmorList
  },
  data() {
    return {
      notFound: false,
      id: null,
      reportId: null,
      vesselId: null
    };
  },
  methods: {
    ...mapActions(["readReport", "fetchReport", "resetVesselReportViewState"]),

    async init() {
      let payload = {
        id: this.id,
        req: { confirm_at: new Date() }
      };
      await this.readReport(payload);
      let ids = { id: this.id, vesselId: this.vesselId };
      await this.fetchReport(ids);
    },

    printReport() {
      window.print();
    },

    cleanup() {
      this.resetVesselReportViewState();
    }
  },
  created() {
    try {
      this.id = this.$route.query.id;
      this.reportId = this.$route.query.reportId;
      this.vesselId = this.$route.query.vesselId;
      this.init();
    } catch (e) {
      this.notFound = true;
    }
  },
  beforeDestroy() {
    this.cleanup();
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/vessel-report-view.scss";
</style>
